import { render, staticRenderFns } from "./PermissionElementBlock.vue?vue&type=template&id=1330b3af&"
import script from "./PermissionElementBlock.vue?vue&type=script&lang=js&"
export * from "./PermissionElementBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports